import { useAuth } from "../context/AuthContext";

export function useAuthorization() {
  const {
    canAccessView,
    isAdmin,
    isPasswordDefault,
    isAuthenticated,
    roles,
  } = useAuth();

  return {
    canAccess: canAccessView,
    isAdmin,
    isPasswordDefault,
    isAuthenticated,
    roles,
  };
}